import { formatPrice } from "./currency";
import { getUnitPrice } from "./variants";

// International visitors do not check out - they enquire on WhatsApp, and the
// message arrives already carrying the product they were looking at.
export const WHATSAPP_NUMBER = "923144201005"; // without '+' or '00'

const productUrl = (product) => {
  if (!product || !product.id) return "";
  const { origin, pathname } = window.location;
  return `${origin}${pathname}#/ProductDetail/${product.id}`;
};

export const buildProductEnquiry = (product, { variant = null, quantity = 1, currency } = {}) => {
  if (!product) return "Hi, I need some information related to your products.";

  const price = getUnitPrice(product, variant, currency);
  const lines = [
    "Hi, I am interested in this product:",
    "",
    `Product: ${product.title}`,
  ];

  if (variant && variant.name) lines.push(`Option: ${variant.name}`);
  lines.push(`Price: ${formatPrice(price)}`);
  if (quantity > 1) lines.push(`Quantity: ${quantity}`);
  if (product.category_name) lines.push(`Category: ${product.category_name}`);

  const url = productUrl(product);
  if (url) {
    lines.push("");
    lines.push(url);
  }

  lines.push("");
  lines.push("Could you share availability and shipping details?");
  return lines.join("\n");
};

export const whatsappLink = (message) =>
  `https://api.whatsapp.com/send?phone=${WHATSAPP_NUMBER}&text=${encodeURIComponent(message)}`;

export const productEnquiryLink = (product, options) =>
  whatsappLink(buildProductEnquiry(product, options));
